__turbopack_context__.v({
  "ChartWrapper": "ProboPrediction-module-scss-module__2ufHEa__ChartWrapper",
  "active": "ProboPrediction-module-scss-module__2ufHEa__active",
  "button": "ProboPrediction-module-scss-module__2ufHEa__button",
  "buttons": "ProboPrediction-module-scss-module__2ufHEa__buttons",
  "card": "ProboPrediction-module-scss-module__2ufHEa__card",
  "chart": "ProboPrediction-module-scss-module__2ufHEa__chart",
  "header": "ProboPrediction-module-scss-module__2ufHEa__header",
  "loader-container": "ProboPrediction-module-scss-module__2ufHEa__loader-container",
  "noButton": "ProboPrediction-module-scss-module__2ufHEa__noButton",
  "switchLabel": "ProboPrediction-module-scss-module__2ufHEa__switchLabel",
  "total-trader": "ProboPrediction-module-scss-module__2ufHEa__total-trader",
  "yesButton": "ProboPrediction-module-scss-module__2ufHEa__yesButton",
});
